const React = require('react')
const PropTypes = require('prop-types')
const { TablePagination } = require('./pagination.table')
const { useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/components/table/header.table.css')

const TableHeader = ({ title, subtitle, usePagination = true, page, limit, totalPages }) => {
    const isMobile = useResponsive(BREAKPOINTS.small)

    return (
        <div className='table-header'>
            <div>
                <div className='table-header-title'>{title}</div>
                <div className='table-header-subtitle'>{subtitle}</div>
                {isMobile && usePagination && (
                    <div className='table-header-pagination d-flex justify-content'>
                        <TablePagination page={page} limit={limit} totalPages={totalPages} />
                    </div>
                )}
            </div>
            {!isMobile && usePagination && <TablePagination page={page} limit={limit} totalPages={totalPages} />}
        </div>
    )
}

TableHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    usePagination: PropTypes.bool,
    page: PropTypes.number,
    limit: PropTypes.number,
    totalPages: PropTypes.number
}

module.exports = { TableHeader }
